import { Link } from 'react-router-dom';

const placeholderLabels = [
  'Coming Soon',
  'Design in Progress',
  'Future Bulldogs Tee',
  'Coming Soon',
  'Design in Progress',
  'Future Bulldogs Tee',
];

const placeholderColors = [
  ['#6B0000', '#FFFFFF', '#808080'],
  ['#F5F5DC', '#6B0000', '#111827'],
  ['#808080', '#FFFFFF', '#6B0000'],
  ['#FFFFFF', '#6B0000', '#808080'],
  ['#6B0000', '#111827', '#FFFFFF'],
  ['#FFFFFF', '#808080', '#6B0000'],
];

const placeholderImages = [
  'https://public.readdy.ai/ai/img_res/7a6f9c70b49a7d85d4f6b27a705e5490.jpg',
  'https://readdy.ai/api/search-image?query=plain%20white%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_home_bs_02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20gray%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_home_bs_03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20cream%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_home_bs_04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20black%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_home_bs_05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20maroon%20long%20sleeve%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_home_bs_06&orientation=portrait',
];

function PlaceholderCard({
  label,
  image,
  colors,
}: {
  label: string;
  image: string;
  colors: string[];
}) {
  return (
    <div className="bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-100 opacity-60 select-none">
      <div className="relative h-80 overflow-hidden bg-gray-50">
        <img
          src={image}
          alt="Coming soon product"
          className="w-full h-full object-contain blur-[2px] scale-105"
        />
        <div className="absolute inset-0 bg-white/40 flex flex-col items-center justify-center gap-2">
          <div className="w-10 h-10 flex items-center justify-center bg-white/80 rounded-full shadow">
            <i className="ri-lock-line text-[#6B0000] text-lg"></i>
          </div>
          <span className="px-4 py-1.5 bg-[#6B0000] text-white text-xs font-bold rounded-full shadow-md tracking-wide">
            {label}
          </span>
        </div>
      </div>

      <div className="p-5">
        <div className="h-4 bg-gray-200 rounded-full w-3/4 mb-3"></div>
        <div className="flex items-center gap-1 mb-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="w-4 h-4 bg-gray-200 rounded-full"></div>
          ))}
          <div className="h-3 bg-gray-200 rounded-full w-10 ml-1"></div>
        </div>
        <div className="flex items-center gap-1.5 mb-4">
          {colors.map((color, i) => (
            <div
              key={i}
              className="w-5 h-5 rounded-full border-2 border-gray-300"
              style={{ backgroundColor: color }}
            ></div>
          ))}
        </div>
        <div className="flex items-center justify-between pt-3 border-t border-gray-100">
          <div className="h-6 bg-gray-200 rounded-full w-16"></div>
          <div className="w-24 h-9 bg-gray-200 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
}

export function BestSellers() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
          <div>
            <span className="inline-block px-4 py-1.5 bg-red-50 text-[#6B0000] text-xs font-bold uppercase tracking-widest rounded-full mb-4">
              Top Picks
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-2">
              Best Selling Bulldogs Shirts
            </h2>
            <p className="text-gray-500 text-lg">Fan favorites flying off the press in Starkville.</p>
          </div>
          <Link
            to="/best-sellers"
            className="inline-flex items-center gap-2 text-[#6B0000] font-bold text-sm hover:gap-3 transition-all whitespace-nowrap"
          >
            View All Best Sellers
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        {/* Coming Soon Notice */}
        <div className="flex items-center gap-4 bg-[#6B0000]/8 border border-[#6B0000]/20 rounded-xl px-6 py-4 mb-10">
          <div className="w-9 h-9 flex items-center justify-center bg-[#6B0000]/10 rounded-full shrink-0">
            <i className="ri-time-line text-[#6B0000] text-lg"></i>
          </div>
          <p className="text-sm text-gray-700">
            <span className="font-bold text-[#6B0000]">Merchandise Coming Soon — </span>
            Our Bulldogs tee collection is being finalized. In the meantime, you can design your own!
          </p>
          <Link
            to="/customize"
            className="ml-auto px-5 py-2 bg-[#6B0000] text-white text-sm font-bold rounded-lg hover:bg-[#550000] transition-colors whitespace-nowrap cursor-pointer"
          >
            Design Your Shirt
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7" data-product-shop>
          {placeholderLabels.map((label, index) => (
            <PlaceholderCard
              key={index}
              label={label}
              image={placeholderImages[index]}
              colors={placeholderColors[index]}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
